export default "__VITE_ASSET__CwE$hTBq__"